$(document).ready(function () {
    for (var i = 1; i <= 2; i++) {
        var $slider = $('.product-group__' + i + '--slider');

        $slider.on('init', function (event, slick) {
            $(this).find('.product-compare-carousel__item').removeClass('product-compare-carousel__item--hide');
        });

        $slider.slick({
            dots: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.product-carousel-navigation__' + i + ' .product-carousel-navigation__arrow--prev'),
            nextArrow: $('.product-carousel-navigation__' + i + ' .product-carousel-navigation__arrow--next'),
            appendDots: $('.product-carousel-navigation__' + i + ' .product-carousel-navigation__dots')
        });
    }
});
